import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaEstudantesLayer from "../components/ListaEstudantesLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaEstudantesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("estudante.breadcrumb.list")} />
      <ListaEstudantesLayer />
    </MasterLayout>
  );
};

export default ListaEstudantesPage;
